define('dcf-collapsible-fieldset',["exports", "./dcf-utility", "./dcf-button-toggle"], function (_exports, _dcfUtility, _dcfButtonToggle) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DCFFieldsetCollapsibleTheme = _exports.DCFFieldsetCollapsible = void 0;
  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
  function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
  var DCFFieldsetCollapsibleTheme = /*#__PURE__*/function () {
    // Sets up the theme
    function DCFFieldsetCollapsibleTheme() {
      _classCallCheck(this, DCFFieldsetCollapsibleTheme);
      this.legendButtonClassList = ['dcf-btn', 'dcf-btn-tertiary', 'dcf-d-inline-block', 'dcf-pt-0', 'dcf-pb-0', 'dcf-pl-1', 'dcf-pr-1', 'dcf-mr-2'];
      this.legendButtonInnerHTMLOn = '-';
      this.legendButtonInnerHTMLOff = '+';
      this.fieldsetContentsClassList = [];
      this.fieldsetContentsClassListOn = ['dcf-h-auto'];
      this.fieldsetContentsClassListOff = ['dcf-h-0', 'dcf-overflow-y-hidden', 'dcf-overflow-x-hidden'];
      this.fieldsetClassList = [];
      this.fieldsetClassListOn = [];
      this.fieldsetClassListOff = [];
      this.animationBlockClassList = ['dcf-motion-none'];
    }

    // Allows us to set the theme variables if they are defined and we match the types
    _createClass(DCFFieldsetCollapsibleTheme, [{
      key: "setThemeVariable",
      value: function setThemeVariable(themeVariableName, value) {
        if (themeVariableName in this && _typeof(value) == _typeof(this[themeVariableName])) {
          this[themeVariableName] = value;
        }
      }
    }]);
    return DCFFieldsetCollapsibleTheme;
  }();
  _exports.DCFFieldsetCollapsibleTheme = DCFFieldsetCollapsibleTheme;
  var DCFFieldsetCollapsible = /*#__PURE__*/function () {
    // Set up the button
    function DCFFieldsetCollapsible(fieldsets, theme) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _classCallCheck(this, DCFFieldsetCollapsible);
      if (theme instanceof DCFFieldsetCollapsibleTheme) {
        this.theme = theme;
      } else {
        this.theme = new DCFFieldsetCollapsibleTheme();
      }
      this.fieldsetReadyEvent = new Event(DCFFieldsetCollapsible.events('fieldsetReady'));
      this.commandToggle = new Event(_dcfButtonToggle.DCFToggleButton.events('commandToggle'));

      // Copy the Keys without copying the references
      // Objects plus their properties and arrays are pass by reference
      this.toggleKeys = [];
      if (Array.isArray(options.toggleKeys)) {
        this.toggleKeys = _toConsumableArray(options.toggleKeys);
      } else if (options.toggleKeys !== null && options.toggleKeys !== undefined && options.toggleKeys !== '') {
        this.toggleKeys.push(options.toggleKeys);
      }
      this.onKeys = [];
      if (Array.isArray(options.onKeys)) {
        this.onKeys = _toConsumableArray(options.onKeys);
      } else if (options.onKeys !== null && options.onKeys !== undefined && options.onKeys !== '') {
        this.onKeys.push(options.onKeys);
      }
      this.offKeys = [];
      if (Array.isArray(options.offKeys)) {
        this.offKeys = _toConsumableArray(options.offKeys);
      } else if (options.offKeys !== null && options.offKeys !== undefined && options.offKeys !== '') {
        this.offKeys.push(options.offKeys);
      }

      // Create a random ID for the button
      this.uuid = _dcfUtility.DCFUtility.uuidv4();

      // Store the button inputted (always will be an array )
      this.fieldsets = fieldsets;
      if (NodeList.prototype.isPrototypeOf(this.fieldsets)) {
        this.fieldsets = Array.from(this.fieldsets);
      } else if (!Array.isArray(this.fieldsets)) {
        this.fieldsets = [this.fieldsets];
      }
    }

    // The names of the events to be used easily
    _createClass(DCFFieldsetCollapsible, [{
      key: "initialize",
      value:
      // Initialize the buttons that were inputted in the constructor
      function initialize() {
        var _this = this;
        // Loops through each one
        this.fieldsets.forEach(function (fieldset, index) {
          // We want to put everything inside the fieldset into a div
          // That div is what will toggle and not the fieldset
          // If we toggle the fieldset then we will also toggle the legend which holds the button

          // Gets value for if it starts expanded or not
          var fieldsetStartExpanded = fieldset.dataset.startExpanded;
          if (fieldsetStartExpanded === undefined) {
            fieldsetStartExpanded = 'true';
          }

          // Checks for legend
          var legend = fieldset.querySelector('legend');
          if (legend === null) {
            throw new Error('Missing Legend In Fieldset');
          }

          // Removed the legend and saves it
          var legendCopy = legend.cloneNode(true);
          legend.remove();
          legendCopy.style.cursor = 'pointer';

          // Creates a new div and we copy everything left in the fieldset into it
          var newGuts = document.createElement('div');
          newGuts.id = _this.uuid.concat('-collapsible-fieldset-contents-', index);
          newGuts.innerHTML = fieldset.innerHTML;
          // We will also add any styles
          _this.theme.fieldsetContentsClassList.forEach(function (divClass) {
            newGuts.classList.add(divClass);
          });
          if (fieldsetStartExpanded === 'true') {
            _this.theme.fieldsetContentsClassListOn.forEach(function (divClass) {
              newGuts.classList.add(divClass);
            });
          } else {
            _this.theme.fieldsetContentsClassListOff.forEach(function (divClass) {
              newGuts.classList.add(divClass);
            });
          }

          // We can then add the new div and legend back into the fieldset
          fieldset.innerHTML = '';
          fieldset.append(legendCopy);
          fieldset.append(newGuts);

          // Block any animations from running on load
          // These get removed during first event listener
          _this.theme.animationBlockClassList.forEach(function (fieldsetClass) {
            fieldset.classList.add(fieldsetClass);
          });

          // We can also add any styles
          _this.theme.fieldsetClassList.forEach(function (fieldsetClass) {
            fieldset.classList.add(fieldsetClass);
          });
          if (fieldsetStartExpanded === 'true') {
            _this.theme.fieldsetClassListOn.forEach(function (fieldsetClass) {
              fieldset.classList.add(fieldsetClass);
            });
          } else {
            _this.theme.fieldsetClassListOff.forEach(function (fieldsetClass) {
              fieldset.classList.add(fieldsetClass);
            });
          }

          // We then make the button to be put into the legend
          var button = document.createElement('button');
          _this.theme.legendButtonClassList.forEach(function (btnClass) {
            button.classList.add(btnClass);
          });
          button.innerHTML = _this.theme.legendButtonInnerHTMLOn;
          button.setAttribute('type', 'button');

          // We set up the toggle button values
          button.dataset.controls = newGuts.id;
          button.dataset.labelOn = 'Expand Fieldset';
          button.dataset.labelOff = 'Collapse Fieldset';
          button.dataset.postfix = index;
          button.dataset.startExpanded = fieldsetStartExpanded;

          // Append the button and initialize it
          legendCopy.prepend(button);

          // We can then add the event listeners
          // We want to do this before the toggle button is initialized
          // Since we have to change the styles for if it starts expanded or not
          _this.eventListeners(fieldset, newGuts, button, legendCopy);

          // Initialize the toggle button
          var toggleButtonObj = new _dcfButtonToggle.DCFToggleButton(button, {
            toggleKeys: _this.toggleKeys,
            onKeys: _this.onKeys,
            offKeys: _this.offKeys
          });
          toggleButtonObj.initialize();

          // This lets any outside js that needs to interact with elements inside the fieldset
          // to know that its safe to create references to these elements
          fieldset.dispatchEvent(_this.fieldsetReadyEvent);
          if (fieldset.getAttribute('hidden') !== null) {
            fieldset.removeAttribute('hidden');
          }

          // Remove the classes related to block any animation
          var removeAnimationBlock = function removeAnimationBlock() {
            _this.theme.animationBlockClassList.forEach(function (fieldsetClass) {
              fieldset.classList.remove(fieldsetClass);
            });
            fieldset.removeEventListener('transitionend', removeAnimationBlock);
          };

          // We want to wait for the css classes to finish changing before removing the classes
          fieldset.addEventListener('transitionend', removeAnimationBlock);
        });
      }

      /**
       * This function will update the styles and HTML for the fieldset, fieldset contents, and the button
       * These events we are listening for come from the DCFToggleButton
       * @param {HTMLElement} fieldset Fieldset that holds the button and toggle element
       * @param {HTMLElement} toggleElement The new div that was made inside the fieldset
       * @param {HTMLElement} button The button that was added to the legend
       * @param {HTMLElement} legend The legend that holds the button
       */
    }, {
      key: "eventListeners",
      value: function eventListeners(fieldset, toggleElement, button, legend) {
        var _this2 = this;
        // If we click the legend and not the button we want to toggle the fieldset
        legend.addEventListener('click', function (event) {
          // If the legend does not contain it then we clicked the SVG and the SVG has changed
          // If e.target is the button we do not want to toggle
          // If the button contains e.target then we do not want to toggle
          if (legend.contains(event.target) && !button.isEqualNode(event.target) && !button.contains(event.target)) {
            button.dispatchEvent(_this2.commandToggle);
          }
        });

        // We listen for when the toggle element is turned on
        toggleElement.addEventListener(DCFFieldsetCollapsible.events('toggleElementOn'), function () {
          // When it is we will remove the off styles and add the on styles
          _this2.theme.fieldsetContentsClassListOff.forEach(function (toggleElementClass) {
            toggleElement.classList.remove(toggleElementClass);
          });
          _this2.theme.fieldsetContentsClassListOn.forEach(function (toggleElementClass) {
            toggleElement.classList.add(toggleElementClass);
          });

          // When it is we will remove the off styles and add the on styles
          _this2.theme.fieldsetClassListOff.forEach(function (fieldsetClass) {
            fieldset.classList.remove(fieldsetClass);
          });
          _this2.theme.fieldsetClassListOn.forEach(function (fieldsetClass) {
            fieldset.classList.add(fieldsetClass);
          });
        });

        // We listen for when the toggle element is turned off
        toggleElement.addEventListener(DCFFieldsetCollapsible.events('toggleElementOff'), function () {
          // When it is we will remove the on styles and add the off styles
          _this2.theme.fieldsetContentsClassListOn.forEach(function (toggleElementClass) {
            toggleElement.classList.remove(toggleElementClass);
          });
          _this2.theme.fieldsetContentsClassListOff.forEach(function (toggleElementClass) {
            toggleElement.classList.add(toggleElementClass);
          });

          // When it is we will remove the on styles and add the off styles
          _this2.theme.fieldsetClassListOn.forEach(function (fieldsetClass) {
            fieldset.classList.remove(fieldsetClass);
          });
          _this2.theme.fieldsetClassListOff.forEach(function (fieldsetClass) {
            fieldset.classList.add(fieldsetClass);
          });
        });

        // We listen for when the toggle button is turned on and update the HTML
        button.addEventListener(DCFFieldsetCollapsible.events('toggleButtonOn'), function () {
          button.innerHTML = _this2.theme.legendButtonInnerHTMLOn;
        });

        // We listen for when the toggle button is turned off and update the HTML
        button.addEventListener(DCFFieldsetCollapsible.events('toggleButtonOff'), function () {
          button.innerHTML = _this2.theme.legendButtonInnerHTMLOff;
        });
      }
    }], [{
      key: "events",
      value: function events(name) {
        // Define any new events
        var events = {
          fieldsetReady: 'ready'
        };
        Object.freeze(events);

        // Forward the events from the DCFToggleButton
        if (_dcfButtonToggle.DCFToggleButton.events(name) !== undefined) {
          return _dcfButtonToggle.DCFToggleButton.events(name);
        }

        // Return the name of the event if it exists if not it will return undefined
        return name in events ? events[name] : undefined;
      }
    }]);
    return DCFFieldsetCollapsible;
  }();
  _exports.DCFFieldsetCollapsible = DCFFieldsetCollapsible;
});

